module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$user.isAdminOrCoordinator) ? _c('graphs') : _vm._e(), _vm._v(" "), (_vm.$user.isClientOrCarrier) ? _c('active-jobs') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-ff8a5f3c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Widgets.vue
// module id = 1090
// module chunks = 0